import { render, staticRenderFns } from "./SkeletonValoraciones.vue?vue&type=template&id=4566925b"
var script = {}
import style0 from "./SkeletonValoraciones.vue?vue&type=style&index=0&id=4566925b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports